import { Component, inject, Input, OnInit } from '@angular/core';
import { NgIf, UpperCasePipe } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { User } from '@shared/interfaces/user';
import { UserService } from '@shared/services/user.service';
import { AbstractFormComponent } from '@shared/components/abstracts/abstract-form.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { CountryCode } from '@shared/enums/coutry-code';
import { plateConfig } from '@shared/consts/plate-config';

@Component({
  selector: 'app-input-license-plate',
  imports: [FormsModule, ReactiveFormsModule, NgIf, UpperCasePipe, TranslateModule],
  templateUrl: './input-license-plate.component.html',
  styleUrls: ['./input-license-plate.component.scss'],
})
export class InputLicensePlateComponent extends AbstractFormComponent implements OnInit {
  environmentConfig = inject(ENVIRONMENT_CONFIG);
  routesPath = this.environmentConfig.routes;

  @Input() cta = 'SHARED.INPUT_LICENSE_PLATE.ACTION';
  @Input() platePlaceholder = this.environmentConfig.plate.placeholder;
  @Input() backgroundColor = '#ffeb28';
  @Input() plateColor = '#3b82f6';
  @Input() isNotFindModalOpen = false;
  @Input() textColor = 'black';
  @Input() useFlag = false;
  @Input() countryCode = this.environmentConfig.plate.code;
  user?: User;

  constructor(
    private userService: UserService,
    private translateService: TranslateService
  ) {
    super(
      new FormGroup({
        licensePlate: new FormControl('', [Validators.required]),
      })
    );
    this.userService.getUser$().subscribe((user) => (this.user = user));
    const config = plateConfig[this.environmentConfig.countryCode[0] as CountryCode];
    if (config) {
      this.countryCode = config.code;
      this.platePlaceholder = config.placeholder;
    }
  }

  @Input()
  set licensePlate(value: string) {
    const licensePlateInput = this.formGroup.get('licensePlate');
    if (licensePlateInput) {
      licensePlateInput.setValue(value);
      this.onSubmit();
    }
  }

  ngOnInit() {
    if (!this.cta) {
      this.translateService.get('SHARED.INPUT_LICENSE_PLATE.ACTION').subscribe((cta) => (this.cta = cta));
    }
  }

  protected override onSubmit(): boolean {
    const licensePlate = this.formGroup.get('licensePlate');
    if (super.onSubmit() && licensePlate) {
      if (this.user && this.user.subscription.isPaidCustomer) {
        window.location.href = `https://funnel.${this.environmentConfig.host}/${this.environmentConfig.langs[0]}/${this.environmentConfig.countryCode[0]}/v1/loading?licenseplate=${licensePlate.value}`;
      } else {
        window.location.href = `https://funnel.${this.environmentConfig.host}/${this.environmentConfig.langs[0]}/${this.environmentConfig.countryCode[0]}/v1/loading-preview?licenseplate=${licensePlate.value}`;
      }
      return true;
    }
    return false;
  }
}
